import { checkStorageLimit, BRANCH_STORAGE_LIMIT } from '../../apis/user.api';

/**
 * Format bytes to human-readable string
 */
export const formatBytes = (bytes: number, decimals: number = 2): string => {
    if (bytes === 0) return '0 Bytes';
    
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

/**
 * Validate file upload against branch storage limit
 * @param branchId - The branch ID
 * @param file - The file to upload
 * @returns Promise with validation result
 */
export const validateStorageBeforeUpload = async (
    branchId: number,
    file: File
): Promise<{ allowed: boolean; message?: string; available?: number; required?: number }> => {
    try {
        const result = await checkStorageLimit(branchId, file.size);
        
        if (!result.allowed) {
            return {
                allowed: false,
                message: result.message || 'Storage limit exceeded',
                available: result.available,
                required: file.size
            };
        }
        
        return {
            allowed: true,
            available: result.available,
            required: file.size
        };
    } catch (error: any) {
        console.error('Storage validation error:', error);
        // On error, allow upload but log warning
        return {
            allowed: true,
            message: 'Could not verify storage limit. Upload may proceed.'
        };
    }
};

/**
 * Get storage limit constant
 */
export const getStorageLimit = (): number => {
    return BRANCH_STORAGE_LIMIT;
};

/**
 * Calculate storage percentage used
 */
export const calculateStoragePercentage = (used: number, limit: number = BRANCH_STORAGE_LIMIT): number => {
    return Math.min(100, (used / limit) * 100);
};
